const initScrollTo = () => {
  const scrollItems = document.querySelectorAll('.scroll-to');

  [...scrollItems].forEach((scrollItem: Element) => {
    const target = scrollItem.getAttribute('href');

    scrollItem.addEventListener('click', (e) => {
      e.preventDefault();

      const targetID = target.replace('#', '');
      const targetDiv = document.getElementById(`${targetID} `);

      targetDiv.scrollIntoView({ behavior: 'smooth' });
    });
  });
};

export default initScrollTo;
